import { render, staticRenderFns } from "./ConfirmAtionBox.vue?vue&type=template&id=3c772164"
import script from "./ConfirmAtionBox.vue?vue&type=script&lang=ts"
export * from "./ConfirmAtionBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../Yobo/qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports